import { TitleHead, Prescription, License, User, ListItem, PrescriptionStatus, Location, Direction, LicenseStatus, TypeActivity, DocumentType, GovernmentAgency } from "../types/data";

export const TitleHeadPrescription: TitleHead[] = [
  {
    id: 1,
    title: 'Номер предписания'
  },
  {
    id: 2,
    title: 'Локация'
  },
  {
    id: 3,
    title: 'Направление'
  },
  {
    id: 4,
    title: 'Дата проведения проверки'
  },
  {
    id: 5,
    title: 'Ответственный'
  },
  {
    id: 6,
    title: 'Статус предписания'
  },
  {
    id: 7,
    title: 'Срок исполнения по предписанию'
  },
  {
    id: 8,
    title: 'Фактическая дата закрытия предписания'
  },
  {
    id: 9,
    title: 'Статус действий'
  },
]

export const TitleHeadLicense: TitleHead[] = [
  {
    id: 1,
    title: 'Номер документа'
  },
  {
    id: 2,
    title: 'Локация'
  },
  {
    id: 3,
    title: 'Тип деятельности'
  },
  {
    id: 4,
    title: 'Тип документа'
  },
  {
    id: 5,
    title: 'Ответственный'
  },
  {
    id: 6,
    title: 'Статус документа'
  },
  {
    id: 7,
    title: 'Дата начала действия'
  },
  {
    id: 8,
    title: 'Дата окончания действия'
  },
  {
    id: 9,
    title: 'Статус действий'
  },
]

export const PrescriptionArray: Prescription[] = [
  {
    id: 1,
    prescriptionNumber: 123456,
    status: {
      id: 1,
      name: 'В процессе'
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 1,
      name: 'Охрана труда'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'В процессе',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  },
  {
    id: 2,
    prescriptionNumber: 498389,
    status: {
      id: 3,
      name: 'Выполнено'
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 3,
      name: 'Пожарная безопасность'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'Закрыто',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  },
  {
    id: 3,
    prescriptionNumber: 96895,
    status: {
      id: 2,
      name: 'Просрочено',
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 3,
      name: 'Пожарная безопасность'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'Не начато',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  },
  {
    id: 4,
    prescriptionNumber: 4785,
    status: {
      id: 3,
      name: 'Выполнено'
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 3,
      name: 'Пожарная безопасность'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'Нет действий',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  },
  {
    id: 5,
    prescriptionNumber: 5773,
    status: {
      id: 3,
      name: 'Выполнено'
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 3,
      name: 'Пожарная безопасность'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'Закрыто',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  },
  {
    id: 6,
    prescriptionNumber: 88585,
    status: {
      id: 1,
      name: 'В процессе'
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 3,
      name: 'Пожарная безопасность'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'Не начато',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  },
  {
    id: 7,
    prescriptionNumber: 34622,
    status: {
      id: 1,
      name: 'В процессе'
    },
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    direction: {
      id: 3,
      name: 'Пожарная безопасность'
    },
    location: {
      id: 1,
      name: 'Казань'
    },
    dateVerification: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    deadlineExecutionOrder: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    actualClosingDatePrescription: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    agencyInspection: 'МЧС',
    scopeVerification: 'Пожарная безопасность',
    typeVerification: 'Выездная',
    fieldActivity: 'Lorem ipsum',
    departmentsAudit: 'Логистика',
    nameRegulatoryDocument: 'Проверка № 1209',
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    identifiedViolations: ['Lorem ipsum', 'Lorem ipsum'],
    actionStatus: 'Закрыто',
    amountFine: '',
    fundsEliminationComments: '',
    comment: '',
    periodicNotificationUpdateDate: {id: 1, name: 'Нет'},
    frequencyRepeatedNotifications: 2,
    dateUpdate: null,
    violations: []
  }
]

export const LicenseArray: License[] = [
  {
    id: 1,
    location: {
      id: 11,
      name: 'Владивосток'
    },
    status: {
      id: 1,
      name: 'В процессе'
    },
    typeActivity: {
      id: 3,
      name: 'Безопасность'
    },
    documentType: {
      id: 2,
      name: 'Выбросы',
    },
    nameDocument: 'Значение',
    documentNumber: 11111,
    startDateDocument: {
      startDate: new Date(2024, 11, 6),
      endDate: new Date(2024, 11, 6)
    },
    expirationDateDocument: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    validityPeriodDocument: 2,
    detailedDescription: 'Значение',
    governmentAgency: {
      id: 3,
      name: 'МЧС',
    },
    namesStateBody: 'Значение',
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    actionStatus: 'В процессе',
    comment: '',
    actions: [],
    dateUpdate: null,
  },
  {
    id: 2,
    location: {
      id: 11,
      name: 'Владивосток'
    },
    status: {
      id: 4,
      name: 'В архиве'
    },
    typeActivity: {
      id: 3,
      name: 'Безопасность'
    },
    documentType: {
      id: 2,
      name: 'Выбросы',
    },
    nameDocument: 'Значение',
    documentNumber: 11111,
    startDateDocument: {
      startDate: new Date(2024, 11, 6),
      endDate: new Date(2024, 11, 6)
    },
    expirationDateDocument: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    validityPeriodDocument: 2,
    detailedDescription: 'Значение',
    governmentAgency: {
      id: 3,
      name: 'МЧС',
    },
    namesStateBody: 'Значение',
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    actionStatus: 'В процессе',
    comment: '',
    actions: [],
    dateUpdate: null,
  },
  {
    id: 3,
    location: {
      id: 11,
      name: 'Владивосток'
    },
    status: {
      id: 2,
      name: 'Действующий'
    },
    typeActivity: {
      id: 3,
      name: 'Безопасность'
    },
    documentType: {
      id: 2,
      name: 'Выбросы',
    },
    nameDocument: 'Значение',
    documentNumber: 11111,
    startDateDocument: {
      startDate: new Date(2024, 11, 6),
      endDate: new Date(2024, 11, 6)
    },
    expirationDateDocument: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    validityPeriodDocument: 2,
    detailedDescription: 'Значение',
    governmentAgency: {
      id: 3,
      name: 'МЧС',
    },
    namesStateBody: 'Значение',
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    actionStatus: 'В процессе',
    comment: '',actions: [],
    dateUpdate: null,
  },
  {
    id: 4,
    location: {
      id: 11,
      name: 'Владивосток'
    },
    status: {
      id: 1,
      name: 'В процессе'
    },
    typeActivity: {
      id: 3,
      name: 'Безопасность'
    },
    documentType: {
      id: 2,
      name: 'Выбросы',
    },
    nameDocument: 'Значение',
    documentNumber: 11111,
    startDateDocument: {
      startDate: new Date(2024, 11, 6),
      endDate: new Date(2024, 11, 6)
    },
    expirationDateDocument: {
      startDate: new Date(2024, 11, 11),
      endDate: new Date(2024, 11, 11)
    },
    validityPeriodDocument: 2,
    detailedDescription: 'Значение',
    governmentAgency: {
      id: 3,
      name: 'МЧС',
    },
    namesStateBody: 'Значение',
    responsible: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    interestedParties: {
      id: 1,
      avatar: '/src',
      name: 'Иванов Иван',
      serviceNumber: 123
    },
    actionStatus: 'В процессе',
    comment: '',
    actions: [],
    dateUpdate: null,
  },
]

export const DocumentsType = [
  {
    id: 1,
    name: 'Общезаводские документы',
  },
  {
    id: 2,
    name: 'Выбросы',
  },
  {
    id: 3,
    name: 'Отходы',
  },
];

export const Users: User[] = [
  {
    id: 1,
    avatar: '/src',
    name: 'Иванов Иван',
    serviceNumber: 123
  },
  {
    id: 2,
    avatar: '/src',
    name: 'Петров Иван',
    serviceNumber: 123
  },
  {
    id: 3,
    avatar: '/src',
    name: 'Попов Иван',
    serviceNumber: 123
  },
]

export const AnswerOptions = [
  {
    id: 1,
    name: 'Нет'
  },
  {
    id: 2,
    name: 'Да'
  }
];

// List SP
export const PrescriptionStatuses: ListItem<PrescriptionStatus>[] = [
  {
    id: 1,
    name: 'В процессе'
  },
  {
    id: 2,
    name: 'Просрочено',
  },
  {
    id: 3,
    name: 'Выполнено'
  }
];

export const LicenseStatuses: ListItem<LicenseStatus>[] = [
  {
    id: 1,
    name: 'В процессе'
  },
  {
    id: 2,
    name: 'Действующий'
  },
  {
    id: 3,
    name: 'Просрочен'
  },
  {
    id: 4,
    name: 'В архиве'
  }
];

export const Directions: ListItem<Direction>[] = [
  {
    id: 1,
    name: 'Охрана труда',
  },
  {
    id: 2,
    name: 'Промышленная безопасность'
  },
  {
    id: 3,
    name: 'Пожарная безопасность'
  },
  {
    id: 4,
    name: 'ГОиЧС'
  },
  {
    id: 5,
    name: 'Экология'
  },
  {
    id: 6,
    name: 'РАТК'
  },
  {
    id: 7,
    name: 'Роспотребнадзор'
  },
  {
    id: 8,
    name: 'Россельхознадзор'
  }
];

export const Activities: ListItem<TypeActivity>[] = [
  {
    id: 1,
    name: 'Экология'
  },
  {
    id: 2,
    name: 'Качество'
  },
  {
    id: 3,
    name: 'Безопасность'
  },
];

export const DocumentTypes: ListItem<DocumentType>[] = [
  {
    id: 1,
    name: 'Общезаводские документы',
  },
  {
    id: 2,
    name: 'Выбросы',
  },
  {
    id: 3,
    name: 'Отходы',
  },
  {
    id: 4,
    name: 'Побочные продукты',
  },
  {
    id: 5,
    name: 'Водоснабжение и водоотведение',
  },
  {
    id: 6,
    name: 'Недропользование',
  },
  {
    id: 7,
    name: 'Другое',
  },
  {
    id: 8,
    name: 'Лицензии',
  },
  {
    id: 9,
    name: 'Декларации',
  },
  {
    id: 10,
    name: 'Побочные продукты (все)',
  },
  {
    id: 11,
    name: 'Пищевая безопасность',
  },
  {
    id: 12,
    name: 'Промышленная безопасность',
  },
  {
    id: 13,
    name: 'Охрана труда',
  },
  {
    id: 14,
    name: 'Пожарная безопасность',
  },
  {
    id: 15,
    name: 'Радиационная безопасность',
  },
  {
    id: 16,
    name: 'ГО и ЧС',
  },
  {
    id: 17,
    name: 'Электробезопасность',
  },
];

export const Locations: ListItem<Location>[] = [
  {
    id: 1,
    name: 'Казань',
  },
  {
    id: 2,
    name: 'Омск'
  },
  {
    id: 3,
    name: 'Россия'
  },
  {
    id: 4,
    name: 'Иваново'
  },
  {
    id: 5,
    name: 'Калуга'
  },
  {
    id: 6,
    name: 'Клин'
  },
  {
    id: 7,
    name: 'Новосибирск'
  },
  {
    id: 8,
    name: 'Саранск'
  },
  {
    id: 9,
    name: 'Уфа'
  },
  {
    id: 10,
    name: 'Ульяновск'
  },
  {
    id: 11,
    name: 'Владивосток'
  },
  {
    id: 12,
    name: 'Волжский'
  },
  {
    id: 13,
    name: 'Солодовня Казань'
  },
  {
    id: 14,
    name: 'Солодовня Саранск'
  },
  {
    id: 15,
    name: 'Солодовня Омск'
  },
  {
    id: 16,
    name: 'ПЭТ производство Казань'
  },
];

export const GovernmentAgencies: ListItem<GovernmentAgency>[] = [
  {
    id: 1,
    name: 'МВД',
  },
  {
    id: 2,
    name: 'Минприроды',
  },
  {
    id: 3,
    name: 'МЧС',
  },
  {
    id: 4,
    name: 'Росприроднадзор',
  },
  {
    id: 5,
    name: 'Росреестр',
  },
  {
    id: 6,
    name: 'Ростехнадзор',
  },
  {
    id: 7,
    name: 'Государственная инспекция труда',
  },
  {
    id: 8,
    name: 'Роспотребнадзор',
  },
  {
    id: 9,
    name: 'Росалкогольтабакконтроль',
  },
  {
    id: 10,
    name: 'Россельхознадзор',
  },
  {
    id: 11,
    name: 'Росводресурсы',
  },
  {
    id: 12,
    name: 'Роснедра',
  },
  {
    id: 13,
    name: 'Рослесхоз',
  },
  {
    id: 14,
    name: 'Росгидромет',
  },
  {
    id: 15,
    name: 'Росстат',
  },
];
